import { Pipe, PipeTransform } from '@angular/core';

/*
 * Filter down an array of objects based on a provided value
 * Usage:
 *   value | dataFilter:[array, filterProperty]
 *   value | dataFilter:[array, filterProperty, returnProperty]
 * Example:
 *   {{ "MI" |  dataFilter:[states, "code", "name"]}}
 *   formats to: If an item is found in the states array with a code of "MI", it will return the name, "Michigan"
 *   {{ "MI" |  dataFilter:[states, "code"]}}
 *   formats to: If an item is found in the states array with a code of "MI", it will return the full state object
 */

@Pipe({
    name: 'dataFilter',
    standalone: true
})
export class DataFilterPipe implements PipeTransform {
	transform(value: any, args: any[]): any {
		const numberValue = parseInt(value);
		const valueForCompare = isNaN(numberValue) ? value : numberValue;
		const arrayToMatch = args[0];
		const filterProperty = args[1];
		const returnProperty = args[2] || '';
		const item = arrayToMatch.filter((x: any) => x[filterProperty] === valueForCompare);

		if (item && item.length === 1) {
			if (returnProperty === '') {
				return item[0];
			} else {
				return item[0][returnProperty];
			}
		}
	}
}
